export default __webpack_public_path__ + "static/media/profile.ea56c0e4.jpg";